<template>
  <div class="notification-card">
    <div class="wrapper">
      <header>
        <h4 class="notification-card__name">{{name}}</h4>
      </header>
      <div class="notification-card__content">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="notification-card__action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationCard',
  props: {
    name: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-card {
  display: flex;
  align-items: center;
  background: $setting-background;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 24px 64px 24px 28px;
  margin-bottom: 20px;
  .wrapper {
    flex: 1;
    flex-direction: column;
  }
  header {
    margin-bottom: 16px;
  }
  &__name {
    font-weight: bold;
    font-size: 20px;
    color: $setting-black-color;
  }
  &__content {
    font-size: 16px;
    line-height: 19px;
    color: $setting-dark-color;
    p {
      font-size: 16px;
      line-height: 19px;
      color: $setting-dark-color;
      margin-bottom: 0;
    }
  }
  &__action {
    margin-left: 80px;
  }
}
</style>
